import { useData } from "./DataContext.js";

import StrictModeDroppable from "./StrictModeDroppable.js";
import DocumentDraggable from "./DocumentDraggable.js";

export default function CollectionDroppable (props)
{
    const gData = useData();
    
    const collectionDocumentIds = gData.state.reports[props.solutionId].collection.documentIds;
    const documentDraggables = collectionDocumentIds.map((documentId, index) => (<DocumentDraggable key={documentId} index={index} documentId={documentId} variableId={null} value="collection"/>));
    const droppableId = props.solutionId + "/collection/collection";

    const width = gData.content.params.documentWidth + 4*2 || "auto";
    const height = (gData.content.params.documentHeight*2 + 4*3) * 5 + 16*4 || "auto";
    //const height = "290px";

    return (
	<StrictModeDroppable droppableId={droppableId}>
	    {(provided, snapshot) => {
		const isDraggingOver = snapshot.isDraggingOver;
		const borderColor = "secondary";
		const bgColor = isDraggingOver ? "bg-secondary-subtle " : "bg-white ";

		return (
		    <div className={"border border-0 rounded rounded-1 m-0 p-1 gap-0 d-flex flex-column align-items-start " + bgColor + borderColor} style={{ width, height, outline: "2px solid var(--bs-"+borderColor+"-border-subtle)" }}
			 ref={provided.innerRef}
			     { ...provided.droppableProps }
		    >
			{documentDraggables}
			{provided.placeholder}
		    </div>
		);
	    }}
	</StrictModeDroppable>
    );
}
